import {
  Guest,
  ReceiveOptions,
} from '@/app/system/guest/Guest';

/**
 * Патрон - это постоянный посетитель
 */
export class Patron<T> implements Guest<T> {
  public constructor(private willBePatron: Guest<T>) {}

  public introduction() {
    return 'patron' as const;
  }

  public receive(value: T, options?: ReceiveOptions): this {
    this.willBePatron.receive(value, options);
    return this;
  }
}
